import { atomWithReset as stateSegmentWithReset } from 'jotai/utils';

export type FileUploads = {
  isLoading: boolean;
  fileName: string;
  fileUploaded: boolean;
  fileUploading: boolean;
  fileUploadError: boolean;
  fileProcessing: boolean;
  fileProcessed: boolean;
  fileProcessedError: boolean;
  fileProcessingErrorStatus: string;
  fileProcessingError: boolean;
  fileDeleting: boolean;
  fileDeleted: boolean;
  sessionId: string;
  error: string | null;
  errorTitle: string | null;
  success: string | null;
  fileUploadPercentage: number;
  sessionLoading: boolean;
  sessionLoaded: boolean;
  fileAnalyzing: boolean;
  fileAnalyzed: boolean;
  fileCompleted: boolean;
  fileProcessPercentage: number;
  sessionFileName: string;
  // Session restore fields
  restore: boolean;
  contextSessionId: string;
  sessionContextRestored: boolean;
  sessionDetailsFetched: boolean;
};

export const fileUploadSegment = stateSegmentWithReset<FileUploads>({
  isLoading: false,
  fileName: '',
  fileUploaded: false,
  fileUploading: false,
  fileUploadError: false,
  fileProcessing: false,
  fileProcessed: false,
  fileProcessedError: false,
  fileProcessingErrorStatus: '',
  fileProcessingError: false,
  sessionId: '',
  error: null,
  errorTitle: null,
  success: null,
  fileUploadPercentage: 0,
  fileDeleting: false,
  fileDeleted: false,
  sessionLoading: false,
  sessionLoaded: false,
  fileAnalyzing: false,
  fileAnalyzed: false,
  fileCompleted: false,
  fileProcessPercentage: 0,
  sessionFileName: '',
  // Session restore fields
  restore: false,
  contextSessionId: '',
  sessionContextRestored: false,
  sessionDetailsFetched: false,
});

fileUploadSegment.debugLabel = 'fileUploadSegment';
